import React from "react";
import { FaArrowRight } from "react-icons/fa";
import heroImage from "../assets/images/hero.png";

const Hero = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Left Column */}
        <div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-snug md:leading-tight">
            Manage your freelance business effortlessly
          </h1>

          <p className="text-lg text-gray-600 mb-6">
            Create invoices, track payments, and grow your freelance income with
            TruPay.
          </p>

          {/* Email Input Group */}
          <div className="relative max-w-md mb-6">
            <input
              type="email"
              placeholder="Enter Business Email"
              className="w-full pl-4 pr-36 py-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
            <button className="group absolute top-1/2 -translate-y-1/2 right-2 bg-teal-500 text-white px-5 py-2 rounded-md flex items-center gap-2 hover:bg-teal-600 transition">
              Get Started{" "}
              <FaArrowRight className="-rotate-45 group-hover:rotate-0 transition-transform duration-300" />
            </button>
          </div>

          {/* Trusted By Section */}
          <p className="text-sm text-gray-500 mb-2">Trusted by teams at:</p>
          <div className="flex gap-6 flex-wrap items-center text-gray-600 text-sm font-semibold">
            <span>Shopify</span>
            <span>Slack</span>
            <span>Notion</span>
            <span>Dropbox</span>
            <span>Figma</span>
          </div>
        </div>

        {/* Right Column */}
        <div className="hidden md:flex justify-center">
          <img
            src={heroImage}
            alt="Hero visual"
            className="w-full max-w-md md:max-w-full animate-softbounce"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
